
import React, { Component } from 'react'
import { Row, Col, Divider, Button, DatePicker, Select, Modal, Icon, message, Table, Input } from 'antd'
import { CSVLink } from 'react-csv'
import { connect } from 'react-redux'
import moment from 'moment'
import $ from 'jquery'

// Actions

import { 
    get_users, 
    save_compassionate_leave, 
    get_compassionate_leave,
    delete_compassionate_leave,
    update_compassionate_leave } from './actions/leave.action'

import './style.css'

// New 

import NewCompLeave from './childs/new.leave'

const dateFormat = 'YYYY/MM/DD';
const { MonthPicker, RangePicker, WeekPicker } = DatePicker;
const Option = Select.Option;
const confirm = Modal.confirm;

class CompassionateLeave extends Component {

    constructor( props ){
        super( props );

        this.state = {
            data: [],
            download_csv: [],
            users_list: [],
            visible: false
        }

        this.handleNewLeave = this.handleNewLeave.bind( this );
        this.submitLeave = this.submitLeave.bind( this );
        this.getColumnSearchProps = this.getColumnSearchProps.bind( this );
        this.handleLeaveDates = this.handleLeaveDates.bind( this );
        this.handleDeleteLeave = this.handleDeleteLeave.bind( this );
        this.DateDiff = this.DateDiff.bind( this );

    }

    handleDeleteLeave( id ){
        let self = this;

        confirm({
            title: 'Do you Want to delete this Leave?',
            onOk() {
                self.props.delete_compassionate_leave( id );
            },
            onCancel() {
                // Nothing
            },
        });

        
    }

    handleLeaveDates( dates, id ){
        this.props.update_compassionate_leave( id, dates[0], dates[1] );
    }

    DateDiff(start, end) {
        
        let date1 = new Date( start );
        let date2 = new Date( end );
        let diffTime = Math.abs(date2 - date1);
        let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 

        return diffDays+1;

    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}>
                    Search
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>Reset</Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                    setTimeout(() => this.searchInput.select() );
                }
        }
    });


    handleSearch = (selectedKeys, confirm) => {
        confirm();
        this.setState({ searchText: selectedKeys[0] });
    }
    
    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    }

    submitLeave( data ){
        this.props.save_compassionate_leave( data );
    }

    componentWillReceiveProps( nextProps ){

        if( nextProps.compleave.length !== 0 ){
            
            if( nextProps.compleave.STATUS.CODE === '200' && 
                nextProps.compleave.STATUS.MESSAGE === 'Get Employee List' ) {
                this.setState({ users_list: nextProps.compleave.OUTPUT.DATA })

            }

            if( nextProps.compleave.STATUS.CODE === '200' && 
                nextProps.compleave.STATUS.MESSAGE === 'Successfully Saved Compassionate leave' ) {
                this.setState({visible: false });
                message.success( nextProps.compleave.STATUS.MESSAGE );
                this.props.get_compassionate_leave();
            }

            if( nextProps.compleave.STATUS.CODE === '200' && 
                nextProps.compleave.STATUS.MESSAGE === 'Successfully Listed Compassionate Leaves' ) {
                this.setState({ data: nextProps.compleave.OUTPUT.DATA });
            }

            if( nextProps.compleave.STATUS.CODE === '200' && 
                nextProps.compleave.STATUS.MESSAGE === 'Successfully Deleted Comp Leave' ) {
                this.props.get_compassionate_leave();
            }

            if( nextProps.compleave.STATUS.CODE === '200' && 
                nextProps.compleave.STATUS.MESSAGE === 'Successfully Updated Comp Leave' ) {
                this.props.get_compassionate_leave();
            }


        }
    
    }

    componentWillMount(){
        this.props.get_users();
        this.props.get_compassionate_leave();
    }

    handleNewLeave(){
        this.setState({visible: true});
    }

    render() {

        const columns_list = [
            {
                title: 'Employee Name',
                dataIndex: 'full_name',
                key: 'full_name',
                ...this.getColumnSearchProps( 'full_name' ),
                width: '50%'
            },{
                title : 'From - To Date',
                render: ( data ) => <span>
                    <RangePicker 
                        value={[ moment( data.start_date, dateFormat ), moment( data.end_date, dateFormat ) ]}
                        onChange={ (date, dateString )=> this.handleLeaveDates( dateString, data.comp_leave_id ) } />
                </span>,
                width: '20%'
            },{
                title: 'Count',
                render: ( data ) => <span>
                    { this.DateDiff( data.start_date, data.end_date) }
                </span>,
                width: '20%'
            },{
                title: 'Actions',
                render: ( data ) => <span>
                    <Button 
                        onClick={ ()=> this.handleDeleteLeave( data.comp_leave_id ) }
                        icon="delete" type="danger"
                        className="table_delete" />
                </span>,
                width: '10%'
            }
        ];

        return (
            
            <div className="comp_leaves_wrapper">
                
                <Row gutter={16}>
                    <Col span={12}>
                        <h2>
                            <Icon type="solution" />
                            &nbsp; Compassionate Leaves
                        </h2>
                    </Col>
                    <Col span={12}>

                        <Button
                            onClick={ this.handleNewLeave }
                            className="fl_right" type="primary" icon="plus">Add Compassionate Leave</Button>

                    </Col>
                </Row>

                <Divider />

                <Table dataSource={ this.state.data } columns={ columns_list } />

                <NewCompLeave 
                    onVisible={ this.state.visible }
                    onUsers={ this.state.users_list }
                    onSubmit={ this.submitLeave } />

            </div>
        )
    }
}

function mapStatetoProps( state ){
    return {
        compleave: state.compleave
    }
}

export default connect( mapStatetoProps, { 
    get_users, 
    save_compassionate_leave,
    get_compassionate_leave,
    delete_compassionate_leave,
    update_compassionate_leave })( CompassionateLeave );


// WEBPACK FOOTER //
// ./src/pages/compassionate_leaves/index.js